import React, { useMemo } from 'react';

type Props = {
    data: any[];
    fields: any[];
};

const CardiologySingleResult: React.FC<Props> = ({ data, fields }) => {

    const score = useMemo(() => {
        if (!data?.length || !fields?.length) return 0;

        const scoreField = fields.find(
            (f: any) => f.name === 'Score'
        );

        if (!scoreField) return 0;

        const rawValue = data[0]?.[scoreField.id];

        return Number(rawValue) || 0;
    }, [data, fields]);

    const getScoreDisplayValue = (score: number): string => {
        if (score < 15) return '<15%';
        if (score < 50) return '15-50%';
        if (score < 85) return '50-85%';
        return '>85%';
    };

    const getScorePosition = (score: number) => {
        const position = 100 - score;
        if (position < 0.5) return 0.5;
        if (position > 96.3) return 96.3;
        return position;
    };

    return (
        <div className="cardiology_patientScoreSection_content_scoreSection">
            <div className="cardiology_patientScoreSection_content_scoreSection_left">
                <div className="cardiology_patientScoreSection_content_scoreSection_left_content">
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div>
                            <div className="cardiology_patientScoreSection_content_scoreSection_left_content_score">
                                {getScoreDisplayValue(score)}
                            </div>
                            <div className="cardiology_patientScoreSection_content_scoreSection_left_content_scoreDescription">
                                Clinic + CCS Model
                            </div>
                        </div>
                    </div>

                    <div className="cardiology_patientScoreSection_content_scoreSection_left_content_scoreDescription2">
                        <b>Intermediate</b> pre-test probability of coronary artery disease.
                    </div>
                </div>
            </div>

            <div className="cardiology_patientScoreSection_content_scoreSection_right">
                <div className="score-rectangle">
                    <div className="high">High</div>
                    <div className="med">Med</div>
                    <div className="low">Low</div>
                    <div className="zero" />
                    <div
                        className="yourRisk"
                        style={{
                            top: `calc(${getScorePosition(score)}% - 4px)`,
                        }}
                    >
                        <div className="rect" />
                        ← Your Risk
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CardiologySingleResult;
